@if (block(); as block) {
  <article class="block-default container" [class.is--odd]="reversedOrder()">
    <div class="row" [class.flex-row-reverse]="reversedOrder()">
      <figure class="col-md-12 mb-md-0 block-default__figure" [class.offset-md-1]="reversedOrder()">
        @if (block.videoUrl) {
          <app-youtube
            [ngClass]="reversedOrder() ? 'pull-md-e' : 'pull-md-s'"
            class="d-block"
            [url]="block.videoUrl"
            [cookiePreferences]="cookiePreferences()"
          ></app-youtube>
        }
        @if (!block.videoUrl && block.image && block.image?.url) {
          <fstr-image
            class="d-block"
            [ngClass]="reversedOrder() ? 'pull-md-e ' : 'pull-md-s '"
            [image]="block.image"
            [height]="600"
            [width]="900"
          ></fstr-image>
        }
      </figure>
      <div class="col-md-11 pt-3 pt-md-4 block-default__content" [ngClass]="reversedOrder() ? '' : 'offset-md-1'">
        @if ((block.title || block.subtitle) && !block.hideTitle) {
          <header>
            @if (block.subtitle) {
              <strong class="fs-body-md fw-semi mb-2 text-primary d-inline-block w-100">{{ block.subtitle }}</strong>
            }
            @if (block.title) {
              <h2 class="h3 mb-0">
                {{ block.title }}
              </h2>
            }
          </header>
        }
        @if (block.text) {
          <main class="mt-3">
            <div
              class="markdown-content"
              fstrDynamicContent
              [innerHTML]="block.text | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
            ></div>
          </main>
        }

        @if (block.button?.url || block.secondaryButton?.url) {
          <footer class="mt-4 d-flex flex-wrap gap-2">
            @if (block.button?.url) {
              <fstr-link [button]="block.button!" [cssClasses]="'button button--primary'"></fstr-link>
            }
            @if (block.secondaryButton?.url) {
              <fstr-link [button]="block.secondaryButton!" [cssClasses]="'button button--primary-subtle'"></fstr-link>
            }
          </footer>
        }
      </div>
    </div>
  </article>
}
